export default __webpack_public_path__ + "static/media/Palco.26a8d99f.jpg";